<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header pb-0">
                <h6>Lokasi Kantor</h6>
                <p class="text-xs text-secondary mb-0">
                  Dipakai untuk validasi lokasi absensi mobile (geofence) &mdash; karyawan hanya bisa absen jika berada dalam radius salah satu lokasi aktif di bawah ini.
                </p>
              </div>
            </div>
            <div class="col-4 float-right">
              <argon-button
                class="mt-4"
                variant="gradient"
                color="success"
                size="sm"
                @click="create()"
              ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Nama</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Alamat</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Koordinat</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Radius</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Unit</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-sm">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.name }}</span>
                    </td>
                    <td class="align-middle text-sm">
                      <span class="text-secondary text-xs">{{ row.address }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.latitude }}, {{ row.longitude }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.radius_meters }} m</span>
                    </td>
                    <td class="align-middle text-sm">
                      <span class="text-secondary text-xs">{{ row.unit || '-' }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="isActive(row.is_active) ? 'bg-gradient-success' : 'bg-gradient-secondary'"
                      >{{ isActive(row.is_active) ? 'Aktif' : 'Nonaktif' }}</span>
                    </td>
                    <td>
                      <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="edit(row)" title="Edit"></i>
                      <i class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                    </td>
                  </tr>
                  <tr v-if="table.data.length === 0">
                    <td colspan="7" class="text-center text-sm text-secondary py-4">Belum ada lokasi kantor yang diatur.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD/EDIT ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{ form.title }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="row">
          <div class="col-6">
            <label class="form-control-label mt-3">Nama Lokasi <span style="color: red;">*</span></label>
            <input type="text" class="form-control" placeholder="Contoh: Kantor Pusat" v-model="dataLocation.name" required>

            <label class="form-control-label mt-3">Alamat</label>
            <input type="text" class="form-control" placeholder="Alamat lengkap" v-model="dataLocation.address">

            <div class="row">
              <div class="col-6">
                <label class="form-control-label mt-3">Latitude <span style="color: red;">*</span></label>
                <input type="number" step="any" class="form-control" placeholder="-6.2088" v-model="dataLocation.latitude" required @change="onCoordInputChange()">
              </div>
              <div class="col-6">
                <label class="form-control-label mt-3">Longitude <span style="color: red;">*</span></label>
                <input type="number" step="any" class="form-control" placeholder="106.8456" v-model="dataLocation.longitude" required @change="onCoordInputChange()">
              </div>
            </div>

            <label class="form-control-label mt-3">Radius Toleransi (meter) <span style="color: red;">*</span></label>
            <input type="number" class="form-control" placeholder="150" v-model="dataLocation.radius_meters" required>

            <label class="form-control-label mt-3">Unit (opsional)</label>
            <input type="text" class="form-control" placeholder="Kosongkan jika berlaku untuk semua unit" v-model="dataLocation.unit">

            <label class="form-control-label mt-3">Status</label>
            <select class="form-select" v-model="dataLocation.is_active">
              <option :value="true">Aktif</option>
              <option :value="false">Nonaktif</option>
            </select>
          </div>
          <div class="col-6">
            <label class="form-control-label mt-3">Pilih Lokasi di Peta</label>
            <p class="text-xs text-secondary mb-1">Klik pada peta, atau geser pin-nya, untuk menentukan titik lokasi kantor. Lokasi kamu saat ini terdeteksi otomatis.</p>
            <div ref="mapPicker" style="height: 380px; border-radius: 8px; border: 1px solid #e2e8f0;"></div>
          </div>
        </div>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="form.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import officeLocation from '@/services/officeLocation.service';
import akun from '@/services/akun.service';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Leaflet's default marker icon references its image paths relative to the
// CSS file by default, which breaks under webpack bundling (the images
// never resolve) -- this is the standard fix, pointing it at the
// webpack-resolved asset URLs instead.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// Default map center when adding a new location with no coordinates yet --
// Cilegon, Banten (where PT. Buana Centra Karya's plant is located).
const DEFAULT_CENTER = [-5.9916, 106.0180];

export default {
  name: "office-location",
  components: {
    ArgonButton,
    VueFinalModal,
  },
  data() {
    return {
      table: {
        data: []
      },
      form: {
        title: "Add Data",
        show: false
      },
      dataLocation: {},
      role: '',
      mapInstance: null,
      mapMarker: null,
    };
  },
  mounted() {
    this.get();
    this.getRole();
  },
  watch: {
    'form.show'(isOpen) {
      if (isOpen) {
        this.$nextTick(() => this.initMap());
      } else {
        this.destroyMap();
      }
    },
  },
  methods: {
    initMap() {
      // Re-opening the modal re-renders the <div ref="mapPicker">, so any
      // previous Leaflet instance bound to the old DOM node must be torn
      // down first -- Leaflet throws if you init twice on the same element.
      this.destroyMap();

      const hasCoords = this.dataLocation.latitude !== undefined && this.dataLocation.latitude !== '' &&
                         this.dataLocation.longitude !== undefined && this.dataLocation.longitude !== '';
      const center = hasCoords
        ? [parseFloat(this.dataLocation.latitude), parseFloat(this.dataLocation.longitude)]
        : DEFAULT_CENTER;

      const map = L.map(this.$refs.mapPicker).setView(center, hasCoords ? 16 : 13);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors',
        maxZoom: 19,
      }).addTo(map);

      const marker = L.marker(center, { draggable: true }).addTo(map);
      marker.on('dragend', () => {
        const pos = marker.getLatLng();
        this.setCoords(pos.lat, pos.lng);
      });
      map.on('click', (e) => {
        marker.setLatLng(e.latlng);
        this.setCoords(e.latlng.lat, e.latlng.lng);
      });

      this.mapInstance = map;
      this.mapMarker = marker;

      // The modal's open/scale transition finishes after Leaflet has
      // already measured the container, so without this the map renders
      // at the wrong size (or blank) until the user manually interacts with it.
      setTimeout(() => map.invalidateSize(), 250);
    },
    destroyMap() {
      if (this.mapInstance) {
        this.mapInstance.remove();
        this.mapInstance = null;
        this.mapMarker = null;
      }
    },
    setCoords(lat, lng) {
      this.dataLocation.latitude  = lat.toFixed(7);
      this.dataLocation.longitude = lng.toFixed(7);
    },
    onCoordInputChange() {
      const lat = parseFloat(this.dataLocation.latitude);
      const lng = parseFloat(this.dataLocation.longitude);
      if (this.mapMarker && !isNaN(lat) && !isNaN(lng)) {
        const pos = [lat, lng];
        this.mapMarker.setLatLng(pos);
        this.mapInstance.setView(pos);
      }
    },
    get() {
      let context = this;
      Api(context, officeLocation.index()).onSuccess(function(response) {
        context.table.data = response.data.data;
      }).onError(function(error) {
        if (error.response && error.response.status == 404) {
          context.table.data = [];
        } else {
          // A real failure (500/network) previously left the table looking
          // identical to "no locations configured yet" with no indication
          // anything went wrong.
          context.notify('Gagal memuat data lokasi kantor', 'error')
        }
      })
      .call()
    },
    getRole() {
      let context = this;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
        context.role = response.data.data[0].role;
        if (response.data.data[0].role != 'Admin') {
          context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
        }
      }).onError(function(error) {})
      .call()
    },
    isActive(value) {
      return value === true || value === 1 || value === '1';
    },
    create() {
      this.form.show  = true;
      this.form.title = "Add Data";
      this.dataLocation = { radius_meters: 150, is_active: true };
      this.detectCurrentLocation();
    },
    detectCurrentLocation() {
      if (!navigator.geolocation) {
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setCoords(position.coords.latitude, position.coords.longitude);
          if (this.mapInstance && this.mapMarker) {
            const pos = [position.coords.latitude, position.coords.longitude];
            this.mapMarker.setLatLng(pos);
            this.mapInstance.setView(pos, 16);
          }
        },
        () => {
          // Permission denied / unavailable -- the map just stays on the
          // Cilegon default and the user picks a point manually instead.
        },
        { enableHighAccuracy: true, timeout: 8000 }
      );
    },
    edit(row) {
      this.dataLocation = { ...row, is_active: this.isActive(row.is_active) };
      this.form.show  = true;
      this.form.title = 'Edit Data';
    },
    save() {
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.dataLocation.name && context.dataLocation.latitude !== undefined && context.dataLocation.latitude !== '' && context.dataLocation.longitude !== undefined && context.dataLocation.longitude !== '') {
        formData.append('name', context.dataLocation.name);
        formData.append('latitude', context.dataLocation.latitude);
        formData.append('longitude', context.dataLocation.longitude);
        formData.append('radius_meters', context.dataLocation.radius_meters || 150);
        formData.append('address', context.dataLocation.address || '');
        // Omitted (not appended as '') when blank -- an empty-string unit
        // previously got saved as a non-null value, which silently excluded
        // "applies to all units" locations from the mobile geofence check.
        if (context.dataLocation.unit) {
          formData.append('unit', context.dataLocation.unit);
        }
        formData.append('is_active', context.dataLocation.is_active ? 1 : 0);
      } else {
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      if (context.form.title == 'Add Data') {
        api = Api(context, officeLocation.create(formData));
      } else {
        api = Api(context, officeLocation.update(context.dataLocation.id, formData));
      }
      api.onSuccess(function() {
        context.get();
        context.form.show = false;
        context.notify(context.form.title == 'Add Data' ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function() {
        context.notify('Data Gagal di Simpan', 'error')
      })
      .call();
    },
    remove(id) {
      var r = confirm("Anda yakin ingin menghapus lokasi kantor ini ?");
      if (r == true) {
        let context = this;
        Api(context, officeLocation.delete(id)).onSuccess(function() {
          context.get();
          context.notify('Data Successfully Deleted', 'success')
        }).onError(function() {
          context.notify('Gagal menghapus lokasi kantor', 'error')
        }).call();
      }
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { autoClose: 2000 });
      } else {
        toast.error(message, { autoClose: 2000 });
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 900px;
  max-width: 95vw;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>
